// https://github.com/xmaestro/angular2-recaptcha
// https://github.com/xmaestro/angular2-recaptcha/issues/7
import { OnInit, EventEmitter, NgZone } from '@angular/core';
import { environment } from './../../environments/environment';
import { LocaleService } from './seo/locale.service';
import * as Raven from 'raven-js';
var ReCaptchaComponent = /** @class */ (function () {
    function ReCaptchaComponent(zone, localeService, document, window) {
        var _this = this;
        this.zone = zone;
        this.localeService = localeService;
        this.document = document;
        this.window = window;
        this.siteKey = environment.re_captcha_site_key;
        this.version = environment.re_captcha_version ? environment.re_captcha_version : 'v2_normal';
        if (this.window)
            this.window['reCaptchaVerifyCallback'] = function (response) { return _this.zone.run(_this.recaptchaCallback.bind(_this, response)); };
        this.captchaResponse = new EventEmitter();
    }
    Object.defineProperty(ReCaptchaComponent.prototype, "size", {
        get: function () {
            return this.version.replace('v2_', '');
        },
        enumerable: true,
        configurable: true
    });
    ReCaptchaComponent.prototype.recaptchaCallback = function (response) {
        Raven.captureBreadcrumb({
            message: 'ReCaptcha reCaptchaVerifyCallback',
            category: 'ReCaptcha'
        });
        this.captchaResponse.emit(response);
    };
    ReCaptchaComponent.prototype.ngOnInit = function () {
        Raven.captureBreadcrumb({
            message: 'ReCaptcha init',
            category: 'ReCaptcha',
            data: {
                re_captcha_version: this.version
            }
        });
        var doc = this.document.body;
        var script = this.document.createElement('script');
        script.innerHTML = '';
        script.src = 'https://www.google.com/recaptcha/api.js?hl=' + this.localeService.getCurrentLocale();
        script.async = true;
        script.defer = true;
        doc.appendChild(script);
    };
    ReCaptchaComponent.prototype.reset = function () {
        Raven.captureBreadcrumb({
            message: 'ReCaptcha reset',
            category: 'ReCaptcha'
        });
        grecaptcha.reset();
    };
    ReCaptchaComponent.prototype.execute = function () {
        Raven.captureBreadcrumb({
            message: 'ReCaptcha execute',
            category: 'ReCaptcha'
        });
        grecaptcha.execute();
    };
    return ReCaptchaComponent;
}());
export { ReCaptchaComponent };



// WEBPACK FOOTER //
// ./src/app/common-theme/re-captcha.component.ts.pre-build-optimizer.js